import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
import * as pagesConfig from 'src/config/pages-config';
import { Subject } from 'rxjs';
import { Location } from '@angular/common';
/** RouterService */
@Injectable({
    providedIn: 'root',
  })
export class RouterService {

    private _currentModule: string = '';
    private _previousExist: boolean = false;
    /** backBtnPressed */
    public backBtnPressed  = false;
    private timer: any;
    /** header change */
    public headerChange: Subject<void>;
/** previousExist */
    public get previousExist (): boolean {

        return this._previousExist;
    }
    /**
     *
     * @param router
     * @param routesUtilsService
     * @param location
     */
    public constructor (private router: Router, private routesUtilsService: RoutesUtilsService, private location: Location) {
        this.headerChange = new Subject<void>();

        this.router.events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    if (this.routesUtilsService.getHistoryUrl() && this.routesUtilsService.getHistoryUrl().currentURL && !this.routesUtilsService.getHistoryUrl().currentURL.includes('#')) {
                        this._previousExist = true;
                    }
                } else if (event instanceof NavigationEnd) {
                    if (!this.routesUtilsService.getHistoryUrl().currentURL.includes('#')) {
                        // set application page history
                        const backBtnTriggered = this.routesUtilsService.getHistoryUrl().previousUrl === event.url;
                        const historyUrl = {
                            previousUrl: this.routesUtilsService.getHistoryUrl().currentURL,
                            currentURL: event.url,
                            currentStep: -1,
                        };
                        this.routesUtilsService.setHistoryUrl(historyUrl);
                        const previousRoute = this.routesUtilsService.getRouteUsingURL(historyUrl.previousUrl.split('?')[0]);
                        if (backBtnTriggered && previousRoute && previousRoute.confirmationPage) {
                            this.router.navigate([pagesConfig.config.overview.route]);
                        }
                    }

                }
            });
      this.location.subscribe( () => {
            this.checkPagesOfBrowserBackBtn();
   });
    }
/** setCurrentModule */
    public setCurrentModule (currentModule: string): void {
        this._currentModule = currentModule;
    }
/** getCurrentModule */
    public getCurrentModule (): string {
        return this._currentModule;
    }

    /**
     * Takes the path of the title to be setted and changes the titleKey's default value
     * @param titlePath - path of the the object to be setted
     * @param titleKey - new titleKey to be setted
     */
    public setDefaultTitle (titlePath: any, titleKey: string) {
        titlePath.titleKey.DEFAULT = titleKey;
        this.headerChange.next();
    }

    /**
     * check the Browser "back" button is clicked from the Overview page Then users shall be directed the Login page.
     * and  If the Browser "back" button is clicked from any other pages rather than Overview page Then users shall be directed on the Overview page.
     */
    public checkPagesOfBrowserBackBtn () {

            this.backBtnPressed  = true;
            if (!this.routesUtilsService.afterSalesBackBtnFlag) {

            const currentURLBeforeNavigation: string = this.routesUtilsService.getHistoryUrl().currentURL;

            this.timer = setTimeout(() => {

                this.backBtnPressed  = false;

                if (this.timer) {

                    clearTimeout(this.timer);
                }

                const currentURLAfterNavigation = this.routesUtilsService.getHistoryUrl();

                if (currentURLBeforeNavigation.includes(pagesConfig.config.generalError.route)) {

                    this.routesUtilsService.navigateToURL(pagesConfig.config.revocation.hardwareAndSimRevocationOptions.navigation.logout, true);
                } else if (!currentURLBeforeNavigation.includes(pagesConfig.config.overview.route) && !currentURLBeforeNavigation.includes(pagesConfig.config.login.route) &&
                    !currentURLAfterNavigation.currentURL.includes(pagesConfig.config.overview.route)) {

                    this.routesUtilsService.navigateToURL(pagesConfig.config.landingPage.route, true);
                } else if (!currentURLAfterNavigation.currentURL.includes(pagesConfig.config.overview.route)
                    || (currentURLAfterNavigation.currentURL.includes(pagesConfig.config.overview.route) &&
                        currentURLBeforeNavigation.includes(pagesConfig.config.overview.route))) {

                    this.routesUtilsService.navigateToURL(pagesConfig.config.revocation.hardwareAndSimRevocationOptions.navigation.logout, true);
                } else if (currentURLBeforeNavigation.includes(pagesConfig.config.revocation.hardwareAndSimRevocationOptions.navigation.logout) && currentURLAfterNavigation.previousUrl.includes(pagesConfig.config.revocation.hardwareAndSimRevocationOptions.navigation.logout) && currentURLAfterNavigation.currentURL.includes(pagesConfig.config.overview.route)) {

                    this.routesUtilsService.navigateToURL(pagesConfig.config.revocation.hardwareAndSimRevocationOptions.navigation.logout, true);
                }

            }, 300);
        }
        this.routesUtilsService.afterSalesBackBtnFlag = false;

    }
}
